import styled from "styled-components";

export const CookieLink = styled.a`
    color: ${({ theme }) => theme.color.white};
`;
